module.exports = __webpack_public_path__ + "static/media/internshala.ded54f6d.jpg";